import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "@/components/LegalPageLayout";

export const Route = createFileRoute("/help")({
  head: () => ({
    meta: [
      { title: "Help Center — Projects, invoices & Payment Protection | Lumvio" },
      { name: "description", content: "Guides for using Lumvio: set up projects, invite clients, send invoices, use Payment Protection and withdraw your earnings." },
      { name: "keywords", content: "Lumvio help, freelance client portal guide, payment protection how it works, freelance invoicing guide, freelancer withdrawal guide" },
      { property: "og:title", content: "Help Center — Projects, invoices & Payment Protection | Lumvio" },
      { property: "og:description", content: "Step-by-step guides for projects, invoices, Payment Protection and payouts on Lumvio." },
      { property: "og:url", content: "https://lumvio.co/help" },
    ],
    links: [
      { rel: "canonical", href: "https://lumvio.co/help" },
      { rel: "alternate", hrefLang: "en", href: "https://lumvio.co/help" },
      { rel: "alternate", hrefLang: "ar", href: "https://lumvio.co/help" },
      { rel: "alternate", hrefLang: "x-default", href: "https://lumvio.co/help" },
    ],

  }),
  component: HelpPage,
});

function withEmail(text: string, email: string) {
  const parts = text.split(`{{email}}`);
  return parts.flatMap((p, i) =>
    i < parts.length - 1
      ? [
          <span key={`t${i}`}>{p}</span>,
          <a key={`a${i}`} href={`mailto:${email}`}>
            {email}
          </a>,
        ]
      : [<span key={`t${i}`}>{p}</span>],
  );
}

function HelpPage() {
  const { t } = useTranslation();
  const steps = t("helpPage.gettingStarted", { returnObjects: true }) as string[];
  const email = "contact@lumvio.co";
  return (
    <LegalPageLayout title={t("helpPage.title")} updated={t("helpPage.updated")}>
      <p>{withEmail(t("helpPage.intro"), email)}</p>

      <h2>{t("helpPage.gettingStartedHeading")}</h2>
      <ul>
        {steps.map((s, i) => (
          <li key={i}>{s}</li>
        ))}
      </ul>

      <h2>{t("helpPage.paymentsHeading")}</h2>
      <p>
        {t("helpPage.paymentsBody")}{" "}
        <Link to="/payment-protection-refunds">{t("helpPage.paymentsLink")}</Link>
      </p>

      <h2>{t("helpPage.deviceHeading")}</h2>
      <p>
        {t("helpPage.deviceBody")}{" "}
        <Link to="/device-policy">{t("helpPage.deviceLink")}</Link>
      </p>

      <h2>{t("helpPage.contactHeading")}</h2>
      <p>{withEmail(t("helpPage.contactBody"), email)}</p>
    </LegalPageLayout>
  );
}
